import { render, staticRenderFns } from "./dataToday.vue?vue&type=template&id=42d7ef3f&scoped=true"
import script from "./dataToday.vue?vue&type=script&lang=js"
export * from "./dataToday.vue?vue&type=script&lang=js"
import style0 from "./dataToday.vue?vue&type=style&index=0&id=42d7ef3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d7ef3f",
  null
  
)

export default component.exports